<h3 mat-dialog-title>{{ data.title }}</h3>

<div mat-dialog-content>
  <form #myForm="ngForm" (ngSubmit)="submitForm()" [formGroup]="fg">
    <section class="flex-row">
      <mat-form-field>
        <mat-label>{{ data.label }}</mat-label>
        <input
          matInput
          type="number"
          formControlName="number"
          [placeholder]="data.placeholder"
        />
      </mat-form-field>
    </section>
  </form>
</div>

<div mat-dialog-actions [align]="'start'">
  <button (click)="myForm.ngSubmit.emit()" color="primary" mat-flat-button>
    Done
  </button>
  <button [mat-dialog-close]="undefined" type="button" mat-button>
    Cancel
  </button>
</div>
